import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[85vh] flex items-center justify-center overflow-hidden" data-id="element-82">
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,0.3), rgba(0,0,0,0.8)), url('https://images.unsplash.com/photo-1514933651103-005eec06c04b?w=1920&q=80')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed'
    }} data-id="element-83" />

      <div className="relative z-10 flex flex-col items-center text-center px-6 mt-20" data-id="element-84">
        <span className="font-sans text-sm md:text-base tracking-mega-wide text-gold uppercase mb-6 animate-fade-in-up" style={{
        animationDelay: '0.2s'
      }} data-id="element-85">
          Experience The
        </span>

        <h1 className="font-serif text-[62px] md:text-[98px] lg:text-[130px] font-bold text-white mb-6 tracking-wide animate-fade-in-up" style={{
        animationDelay: '0.4s'
      }} data-id="element-86">
          TEMPOO
        </h1>

        <div className="w-24 h-px bg-gold mx-auto mb-8 animate-fade-in-up" style={{
        animationDelay: '0.6s'
      }} data-id="element-87" />

        <p className="font-sans text-base md:text-lg tracking-ultra-wide text-white/70 uppercase animate-fade-in-up" style={{
        animationDelay: '0.8s'
      }} data-id="element-88">
          Where West African Flavor Meets Nightlife
        </p>
      </div>

      <div className="absolute bottom-12 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2" data-id="element-89">
        <ChevronDownIcon className="text-gold animate-bounce-subtle w-8 h-8 opacity-80" data-id="element-90" />
      </div>
    </section>;
}